import { AUTH_BASE_URL } from "../../../constants";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { LOGIN_PATH } from "./constants";
import { encodeSecrets } from "./helper";
import { IUserLoginResponse } from "./models";

// eslint-disable-next-line no-unused-vars
export const signIn: (data: FormData) => Promise<IUserLoginResponse> = (
  data: FormData
) => {
  const headers = {
    Authorization: `Basic ${encodeSecrets()}`,
  };
  const descriptor = new ApiServiceManager(
    `${AUTH_BASE_URL}${LOGIN_PATH}`,
    "POST"
  );
  return fetchRequest(descriptor, data, headers);
};
